
import sortBy from 'lodash/sortBy'
import PropTypes from 'prop-types'

import { COMPANIES_TRANSLATIONS } from '../../lib/companies'
import Select from './Select'

export const MANUFACTURERS = [
  {
    id: 'all',
    name: 'Manufacturers: all',
  },
  ...sortBy(
    Object.keys(COMPANIES_TRANSLATIONS).map(key => ({
      id: key,
      name: COMPANIES_TRANSLATIONS[key],
    })),
    'name',
  ),
]

export default function ManufacturerSelect({ disableAll = false, ...props }) {
  return (
    <Select
      options={disableAll ? MANUFACTURERS.slice(1) : MANUFACTURERS}
      {...props}
      wrapperItem
      placeholder={disableAll ? 'Select manufacturer' : false}
    />
  )
}

ManufacturerSelect.propTypes = {
  disableAll: PropTypes.bool,
}
